import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import PendingForm from './PendingForm';
import ApproveForm from './ApproveForm';
import useMediaQuery from '@mui/material/useMediaQuery';
import RejecttionForm from './RejectionForm';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const orientation = useMediaQuery('(min-width:600px)') ? 'vertical':'horizontal'  ;
  const direction= useMediaQuery('(min-width:600px)') ? 'row':'column'

  return (
    <Box
      sx={{ flexGrow: 1, bgcolor: 'background.paper', display: 'flex',flexDirection:direction}}
    >
      <Tabs
        orientation={orientation}
        variant="scrollable"
        value={value}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderRight: 1, borderColor: 'divider' ,width:useMediaQuery('(min-width:600px)') ? '13%':'100%',height:useMediaQuery('(min-width:600px)') ? '70vh':'5vh'}}
      >
        <Tab label="Pending" {...a11yProps(0)} />
        <Tab label="Approved" {...a11yProps(1)} />
        <Tab label="Rejected" {...a11yProps(2)} />


      </Tabs>
      <div style={{width:useMediaQuery('(min-width:600px)') ? '87%':'100%'}}>
      <TabPanel value={value} index={0}>
        <PendingForm />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ApproveForm status={"Approved"}/>
      </TabPanel>
      <TabPanel value={value} index={2}>
        <RejecttionForm status={"Rejected"}/>
      </TabPanel>
      </div>
    </Box>
  );
}
